import PropTypes from 'prop-types';
import { popoverPlacements } from '../shared/popover/prop_types';
var propTypes = {
  arrow: PropTypes.bool,
  children: PropTypes.element.isRequired,
  content: PropTypes.node.isRequired,
  contentHideDelayOnHover: PropTypes.number,
  contentShowDelayOnHover: PropTypes.number,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  open: PropTypes.bool,
  placement: PropTypes.oneOf(popoverPlacements),
  portal: PropTypes.bool,
  tabIndex: PropTypes.number,
  useJsPositioning: PropTypes.bool,
  userSelect: PropTypes.oneOf(['all', 'auto', 'contain', 'element', 'none', 'text', 'inherit', 'initial', 'revert', 'unset'])
};
export default propTypes;